
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire02cb"];
var parcelRegister = parcelRequire.register;
parcelRegister("jSnoh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7067014ccef9726e$export$2e2bcd8739ae039; });

var $1dxTK = parcelRequire("1dxTK");

var $88yio = parcelRequire("88yio");

var $jIyMJ = parcelRequire("jIyMJ");

var $2ClHf = parcelRequire("2ClHf");

var $fi9H8 = parcelRequire("fi9H8");

var $akEkq = parcelRequire("akEkq");

var $kkRwB = parcelRequire("kkRwB");

var $f37rc = parcelRequire("f37rc");

var $9wkP2 = parcelRequire("9wkP2");

var $jVFwa = parcelRequire("jVFwa");

var $ePYBG = parcelRequire("ePYBG");

var $7NhPg = parcelRequire("7NhPg");

var $bHoW4 = parcelRequire("bHoW4");

var $3o4Tm = parcelRequire("3o4Tm");

var $9kSv6 = parcelRequire("9kSv6");

var $aF0pQ = parcelRequire("aF0pQ");

var $bYDhZ = parcelRequire("bYDhZ");
const $7067014ccef9726e$var$BrickfilmCard = ({ t: t, id: id, title: title, type: type, slug: slug, runtime: runtime, picture: picture, author: author, maxPlayed: maxPlayed, contestRankings: contestRankings, isUnavailable: isUnavailable = false, hideAuthor: hideAuthor = false, numberOfMessages: numberOfMessages = null, hasReplied: hasReplied = false, boostEndsAt: boostEndsAt = null })=>{
    const link = `/brickfilms/${id}/${slug}`;
    const rankingTag = [
        1,
        2,
        3
    ].map((position)=>({
            position: position,
            count: contestRankings?.filter((r)=>r.position === position)?.length || 0
        })).filter((e)=>e.count > 0).map((p)=>t("{{count}}_ordinal", {
            count: p.position,
            ordinal: true
        })).join(" / ");
    let bestPosition = Math.min(...contestRankings?.map((rank)=>rank.position).filter((e)=>e > 0 && e <= 3) || []) || null;
    bestPosition = bestPosition === Infinity ? null : bestPosition;
    return /*#__PURE__*/ (0, $1dxTK.jsxs)((0, $jVFwa.default), {
        disablePadding: true,
        children: [
            /*#__PURE__*/ (0, $1dxTK.jsx)((0, $f37rc.default), {
                action: link,
                title: title,
                children: /*#__PURE__*/ (0, $1dxTK.jsxs)("div", {
                    className: $bYDhZ.banner,
                    children: [
                        /*#__PURE__*/ (0, $1dxTK.jsx)("div", {
                            className: $bYDhZ.image,
                            style: {
                                backgroundImage: `url("${(0, $kkRwB.chooseBestImage)([
                                    (0, (/*@__PURE__*/$parcel$interopDefault($fi9H8))),
                                    (0, (/*@__PURE__*/$parcel$interopDefault($akEkq))),
                                    (0, (/*@__PURE__*/$parcel$interopDefault($2ClHf)))
                                ])}")`
                            }
                        }),
                        /*#__PURE__*/ (0, $1dxTK.jsx)("div", {
                            className: $bYDhZ.image,
                            style: {
                                backgroundImage: `url("${(0, $kkRwB.getPictureLink)(picture, {
                                    w: 400
                                })}")`
                            }
                        }),
                        boostEndsAt && /*#__PURE__*/ (0, $1dxTK.jsx)((0, $7NhPg.default), {
                            color: "var(--theme-medium-purple)",
                            icon: (0, $88yio.faBolt),
                            timestamp: boostEndsAt
                        }),
                        !boostEndsAt && type === "PROJECT" && /*#__PURE__*/ (0, $1dxTK.jsx)((0, $3o4Tm.default), {
                            icon: (0, $88yio.faCameraMovie)
                        }),
                        !boostEndsAt && type === "TEST" && /*#__PURE__*/ (0, $1dxTK.jsx)((0, $3o4Tm.default), {
                            icon: (0, $88yio.faVial)
                        }),
                        !boostEndsAt && bestPosition !== null && /*#__PURE__*/ (0, $1dxTK.jsx)((0, $3o4Tm.default), {
                            className: [
                                $bYDhZ.gold,
                                $bYDhZ.iron,
                                $bYDhZ.bronze
                            ][bestPosition - 1],
                            icon: bestPosition === 1 ? (0, $88yio.faTrophyStar) : (0, $88yio.faTrophy),
                            tag: rankingTag
                        }),
                        !boostEndsAt && type !== "PROJECT" && isUnavailable && /*#__PURE__*/ (0, $1dxTK.jsx)((0, $3o4Tm.default), {
                            icon: (0, $88yio.faBan),
                            tag: t("Unavailable"),
                            position: "RIGHT"
                        }),
                        !isUnavailable && /*#__PURE__*/ (0, $1dxTK.jsx)((0, $9kSv6.default), {
                            time: runtime,
                            position: "RIGHT"
                        }),
                        numberOfMessages !== null && /*#__PURE__*/ (0, $1dxTK.jsx)((0, $3o4Tm.default), {
                            className: numberOfMessages === 0 ? $bYDhZ.warning : "",
                            icon: hasReplied ? (0, $9wkP2.faCommentsValidated) : (0, $88yio.faComments),
                            tag: numberOfMessages,
                            position: "BOTTOM-LEFT"
                        }),
                        /*#__PURE__*/ (0, $1dxTK.jsx)((0, $ePYBG.default), {
                            progress: maxPlayed
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $1dxTK.jsxs)("div", {
                className: $bYDhZ.infos,
                children: [
                    /*#__PURE__*/ (0, $1dxTK.jsx)((0, $f37rc.default), {
                        action: link,
                        title: title,
                        children: /*#__PURE__*/ (0, $1dxTK.jsx)((0, $bHoW4.default), {
                            h: 5,
                            oneLine: true,
                            children: title
                        })
                    }),
                    !hideAuthor && /*#__PURE__*/ (0, $1dxTK.jsx)((0, $aF0pQ.default), {
                        ...author
                    })
                ]
            }),
            boostEndsAt && /*#__PURE__*/ (0, $1dxTK.jsx)("div", {
                className: $bYDhZ.boostedBorder
            })
        ]
    });
};
var $7067014ccef9726e$export$2e2bcd8739ae039 = (0, $jIyMJ.withTranslation)()($7067014ccef9726e$var$BrickfilmCard);

});
parcelRegister("2ClHf", function(module, exports) {
module.exports = new URL("brickfilm.1df794c4.avif", import.meta.url).toString();

});

parcelRegister("fi9H8", function(module, exports) {
module.exports = new URL("brickfilm.755320c4.jpeg", import.meta.url).toString();

});

parcelRegister("akEkq", function(module, exports) {
module.exports = new URL("brickfilm.3c5513fa.webp", import.meta.url).toString();

});

parcelRegister("7NhPg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02a825de7e0be39c$export$2e2bcd8739ae039; });

var $1dxTK = parcelRequire("1dxTK");

var $aX1RZ = parcelRequire("aX1RZ");

var $3o4Tm = parcelRequire("3o4Tm");
const $02a825de7e0be39c$var$CountdownTag = ({ timestamp: timestamp = null, ...rest })=>{
    const [fakeCurrentDate, setFakeCurrentDate] = (0, $aX1RZ.useState)(new Date());
    (0, $aX1RZ.useEffect)(()=>{
        setTimeout(()=>setFakeCurrentDate(new Date()), 1000);
    }, [
        fakeCurrentDate
    ]);
    if (timestamp === null) return null;
    const currentTime = Math.floor(new Date().getTime() / 1000);
    let seconds = timestamp - currentTime;
    if (seconds < 0) seconds = 0;
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor(seconds % 3600 / 60);
    const secs = Math.floor(seconds % 60);
    return /*#__PURE__*/ (0, $1dxTK.jsx)((0, $3o4Tm.default), {
        ...rest,
        tag: `${`${hours}`.padStart(2, "0")}:${`${mins}`.padStart(2, "0")}:${`${secs}`.padStart(2, "0")}`
    });
};
var $02a825de7e0be39c$export$2e2bcd8739ae039 = $02a825de7e0be39c$var$CountdownTag;

});

parcelRegister("bYDhZ", function(module, exports) {

$parcel$export(module.exports, "banner", function () { return $8b83c64e7e310467$export$bb5ee47d9ea2348e; }, function (v) { return $8b83c64e7e310467$export$bb5ee47d9ea2348e = v; });
$parcel$export(module.exports, "boostedBorder", function () { return $8b83c64e7e310467$export$b05550f1a6936414; }, function (v) { return $8b83c64e7e310467$export$b05550f1a6936414 = v; });
$parcel$export(module.exports, "bronze", function () { return $8b83c64e7e310467$export$7ce8b36d0b00eddb; }, function (v) { return $8b83c64e7e310467$export$7ce8b36d0b00eddb = v; });
$parcel$export(module.exports, "gold", function () { return $8b83c64e7e310467$export$c24201f7fe3571d8; }, function (v) { return $8b83c64e7e310467$export$c24201f7fe3571d8 = v; });
$parcel$export(module.exports, "image", function () { return $8b83c64e7e310467$export$5c452ff88e35e47d; }, function (v) { return $8b83c64e7e310467$export$5c452ff88e35e47d = v; });
$parcel$export(module.exports, "infos", function () { return $8b83c64e7e310467$export$8810e945d522ffb1; }, function (v) { return $8b83c64e7e310467$export$8810e945d522ffb1 = v; });
$parcel$export(module.exports, "iron", function () { return $8b83c64e7e310467$export$a922f057b377e32f; }, function (v) { return $8b83c64e7e310467$export$a922f057b377e32f = v; });
$parcel$export(module.exports, "warning", function () { return $8b83c64e7e310467$export$491112666e282270; }, function (v) { return $8b83c64e7e310467$export$491112666e282270 = v; });
var $8b83c64e7e310467$export$bb5ee47d9ea2348e;
var $8b83c64e7e310467$export$b05550f1a6936414;
var $8b83c64e7e310467$export$7ce8b36d0b00eddb;
var $8b83c64e7e310467$export$c24201f7fe3571d8;
var $8b83c64e7e310467$export$5c452ff88e35e47d;
var $8b83c64e7e310467$export$8810e945d522ffb1;
var $8b83c64e7e310467$export$a922f057b377e32f;
var $8b83c64e7e310467$export$491112666e282270;
$8b83c64e7e310467$export$bb5ee47d9ea2348e = `xtrsKG_banner`;
$8b83c64e7e310467$export$b05550f1a6936414 = `xtrsKG_boostedBorder`;
$8b83c64e7e310467$export$7ce8b36d0b00eddb = `xtrsKG_bronze`;
$8b83c64e7e310467$export$c24201f7fe3571d8 = `xtrsKG_gold`;
$8b83c64e7e310467$export$5c452ff88e35e47d = `xtrsKG_image`;
$8b83c64e7e310467$export$8810e945d522ffb1 = `xtrsKG_infos`;
$8b83c64e7e310467$export$a922f057b377e32f = `xtrsKG_iron`;
$8b83c64e7e310467$export$491112666e282270 = `xtrsKG_warning`;

});



//# sourceMappingURL=Homepage.b1393a78.js.map
